module.exports = __webpack_public_path__ + "img/f77d71e.png";